import script from "./AttendanceView.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendanceView.vue?vue&type=script&setup=true&lang=js"

import "./AttendanceView.vue?vue&type=style&index=0&id=a358ee7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a358ee7c"]])

export default __exports__